import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTranslation } from 'react-i18next';

interface CreditHoldDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Reusable dialog explaining the credit-hold status to the customer.
 * Used in two places:
 *   1. Once per login (from CustomerLayout, gated by sessionStorage)
 *   2. On any attempt to place an order while on hold (from cart/checkout)
 */
const CreditHoldDialog: React.FC<CreditHoldDialogProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningAmberIcon color="warning" />
          {t('creditHold.dialog.title')}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mt: 1 }}>
          {t('creditHold.dialog.message')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          {t('common.ok', 'OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreditHoldDialog;
